<template>
  <section
    id="aos-section4"
    class="relative flex w-full flex-col items-center self-stretch overflow-hidden bg-[#f5f8ff] px-5"
  >
    <OptimizedImage
      v-for="(pattern, idx) in bgPatterns"
      :key="`bg_pattern_${idx}`"
      base-path="image/home/bg_pattern"
      :file-name="pattern.fileName"
      :alt="pattern.fileName"
      :image-class="pattern.className"
    />

    <article
      v-for="(article, sectionIdx) in titleDatas"
      :key="`article-${sectionIdx}`"
      class="flex w-full flex-col items-center gap-9 px-4 text-center sm:max-w-[520px] lg:max-w-[1400px] lg:gap-16"
      :class="sectionIdx === 0 ? 'py-[60px] lg:py-[120px]' : 'pb-[60px] lg:pb-[120px]'"
    >
      <div
        :id="article.titleId"
        data-aos="fade-up"
        :data-aos-anchor="article.anchor"
        class="flex flex-col items-center gap-2 lg:gap-3"
      >
        <span v-if="article.subTitle" class="gn-text-xl font-bold text-slate-600">
          {{ $t(article.subTitle) }}
        </span>
        <i18n-t :keypath="article.title" tag="p" class="gn-text-3xl font-bold">
          <template #cbt>
            <span class="font-extrabold">{{ $t('main.section4.cbt') }}</span>
          </template>
          <template #care>
            <span class="font-extrabold">{{ $t('main.section4.care') }}</span>
          </template>
        </i18n-t>
      </div>

      <!-- 카드 그리드 -->
      <div class="grid gap-1 self-stretch sm:grid-cols-2 sm:gap-2 lg:h-[400px] lg:grid-cols-4 lg:gap-4">
        <div
          v-for="num in 4"
          :key="`bg_index_card${sectionIdx + 1}_${num}`"
          data-aos="flip-left"
          :data-aos-anchor="article.anchor"
          :data-aos-delay="400 * num + 200"
          class="relative flex items-end overflow-hidden px-7 py-9 backdrop-blur lg:px-8"
        >
          <OptimizedImage
            base-path="image/home/bg_index_card01"
            :file-name="`bg_index_card0${sectionIdx + 1}_${num}`"
            :alt="$t(`main.section4.cardList${sectionIdx + 1}.text${num}`)"
            img-format="jpg"
            image-class="absolute left-0 bottom-0 opacity-90 object-cover rounded-2xl size-full"
          />
          <p class="gn-text-2xl z-10 whitespace-pre-line text-start font-extrabold text-white">
            {{ $t(`main.section4.cardList${sectionIdx + 1}.text${num}`) }}
          </p>
        </div>
      </div>
    </article>
  </section>
</template>

<script setup>
import OptimizedImage from '~/components/common/OptimizedImage.vue'

const titleDatas = [
  {
    titleId: 'aos-title1',
    anchor: '#aos-section4',
    title: 'main.section4.title1',
    subTitle: 'main.section4.subTitle1'
  },
  {
    titleId: 'aos-titlet2',
    anchor: '#aos-titlet2',
    title: 'main.section4.title2'
  }
]

const bgPatterns = [
  {
    fileName: 'bg_pattern_ia',
    className: `absolute opacity-5
                left-[-20px] top-[-50px] w-[250px] h-auto
                lg:left-[-57px] lg:top-[-18px] lg:w-[446px]`
  },
  {
    fileName: 'bg_pattern_g',
    className: `absolute opacity-5
                right-[-50px] top-[400px] w-[155px] h-auto
                md:top-1/2 lg:right-[-90px] lg:top-[656px] lg:w-[300px]`
  },
  {
    fileName: 'bg_pattern_n',
    className: `absolute opacity-5
                left-0 bottom-[-5px] w-40 h-auto
                md:bottom-[-100px] lg:w-[319px]`
  }
]
</script>

<style lang="scss" scoped></style>
